import {League, LeagueState} from "./League";
import {IApiCup} from "../typings/apiResponse";

/**
 * @ngdoc overview
 *
 * @type {Object}
 * @name ngLeague.Cup
 *
 * @requires apiCup
 *
 * @description
 * The cup object represents a cup on ESL Play. It can be build using an API response for a cup directly or by
 * calling the factory method in {@link ngLeague.League}.
 */
export class Cup extends League {
    constructor(private apiCup: IApiCup) {
        super(apiCup);
        this.apiCup = apiCup;
    }

    public getStateStart(state: string): Date {
        if (this.apiCup.timeline.hasOwnProperty(state)) {
            return new Date(this.apiCup.timeline[state].begin);
        } else {
            return null;
        }
    }

    public getStateEnd(state: string): Date {
        if (this.apiCup.timeline.hasOwnProperty(state)) {
            return new Date(this.apiCup.timeline[state].end);
        } else {
            return null;
        }
    }

    public getSignedUpContestants(): number {
        return this.apiCup.contestants.signedUp;
    }

    public getCheckedInContestants(): number {
        return this.apiCup.contestants.checkedIn;
    }

    public getMaxContestants(): number {
        return this.apiCup.contestants.max;
    }

    isFull(): boolean {
        if (typeof this.apiCup.contestants !== 'object' || isNaN(this.apiCup.contestants.max) || this.apiCup.contestants.max === null || this.apiCup.contestants.max === 0) {
            return false;
        }
        return this.apiCup.contestants.checkedIn >= this.apiCup.contestants.max;
    }

    isSignUpEnabled(): boolean {
        if (this.apiCup.signUp.hasOwnProperty("enabled")) {
            return this.apiCup.signUp.enabled;
        } else {
            return true;
        }
    }

    isStateAvailable(state: string): boolean {
        return !!(typeof this.apiCup.timeline === 'object' && this.apiCup.timeline.hasOwnProperty(state));
    }

    isSignUpAvailable(): boolean {
        return !!(this.isStateAvailable(LeagueState.SIGN_UP) && this.apiCup.timeline.signUp.begin);
    }

    getStartDate(): Date {
        return typeof this.apiCup.timeline === 'object' && this.apiCup.timeline.hasOwnProperty("inProgress") ? new Date(this.apiCup.timeline.inProgress.begin) : new Date(0);
    }

    getNextDate(): Date {
        if (this.apiCup.state !== 'finished' && typeof this.apiCup.timeline === 'object' && this.apiCup.timeline.hasOwnProperty(this.apiCup.state)) {
            var nextState: {end: number} = this.apiCup.timeline[this.apiCup.state];
            return new Date(nextState.end);
        }
        return new Date(0);
    }

    getState():string {
        return this.apiCup.state;
    }

    isInState(state: string): boolean {
        return this.getState() === state;
    }

    public getPrizePool(): string {
        return this.apiCup.prizePool;
    }

    public hasPrizePool(): boolean {
        return typeof this.apiCup.prizePool === 'string';
    }
    
    public getCupMode(): string {
        return this.apiCup.cupMode;
    }
}
